import classnames from 'classnames/bind';
import {Link, Outlet, useMatch, useResolvedPath} from 'react-router-dom';
import styles from './subscriptionSettings.module.scss';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const SUBSCRIPTION_SUBTABS = [
  {
    key: 'plans',
    to: '/dashboard/plans/subscription-setting/plans',
    name: 'Plans',
  },
  {
    key: 'bundles',
    to: '/dashboard/plans/subscription-setting/bundles',
    name: 'Bundles',
  },
  {
    key: 'settings',
    to: '/dashboard/plans/subscription-setting/settings',
    name: 'Settings',
  },
];

const CustomLink = ({to, name}) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({path: resolved.pathname, end: true});
  const cx = classnames.bind(styles);

  return (
    <Link className={cx('nav-link', match ? 'active-toggle' : '')} to={to}>
      <span>{name}</span>
    </Link>
  );
};

const SubscriptionSetting = () => {
  const {visibleSubTabs} = useVisibleSubTabs(
    NavTabsEnum.Subscription,
    SUBSCRIPTION_SUBTABS,
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Subscription Plans</h1>
      </div>
      <section className={styles.section}>
        <nav className={styles.tabs}>
          {visibleSubTabs.map(tab => (
            <CustomLink key={tab.key} to={tab.to} name={tab.name} />
          ))}
        </nav>
      </section>
      <Outlet />
    </div>
  );
};

export default SubscriptionSetting;
